import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ILayoutState } from '@layout/state/layout.reducer';
import { assigneeList } from '@layout/state/layout.selectors';
import { FormControl } from '@angular/forms';
import { ICmmsAssignee } from '@app/pages/cmms/interfaces/assignee.interface';
import { IAssigneeOrganization } from '@shared/interfaces/selectable-options.interfaces';
import { CommonModule } from '@angular/common';
import { AuAssigneeSelectComponent } from '@shared/ui-components';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'cmms-assignee-and-approver',
	templateUrl: './cmms-assigee-and-approver.component.html',
	styleUrls: ['./cmms-assigee-and-approver.component.scss'],
	imports: [CommonModule, AuAssigneeSelectComponent, NgxTolgeeModule],
})
export class CmmsAssigeeAndApproverComponent implements OnInit {
	@Input() set assignee(assignee: ICmmsAssignee) {
		this.assigneeControl.setValue(assignee, {
			emitEvent: false,
		});
	}
	@Input() set approver(approver: ICmmsAssignee) {
		this.approverControl.setValue(approver, {
			emitEvent: false,
		});
	}
	@Input() disableTeamsSelection: boolean = true;
	@Output() assigneeControlReady = new EventEmitter<FormControl>();
	@Output() approverControlReady = new EventEmitter<FormControl>();
	@Output() assigneeUpdate = new EventEmitter<ICmmsAssignee>();
	@Output() approverUpdate = new EventEmitter<ICmmsAssignee>();

	assigneeControl = new FormControl(null);
	approverControl = new FormControl(null);
	assigneeList$: Observable<IAssigneeOrganization[]>;

	constructor(private store$: Store<ILayoutState>) {}

	ngOnInit(): void {
		this.assigneeList$ = this.store$.select(assigneeList);

		this.assigneeControlReady.emit(this.assigneeControl);
		this.approverControlReady.emit(this.approverControl);
	}

	setAssignee(assignee: ICmmsAssignee) {
		this.assigneeControl.setValue(assignee, {
			emitEvent: false,
		});
		this.assigneeUpdate.emit(assignee);
	}

	setApprover(assignee: ICmmsAssignee) {
		this.approverControl.setValue(assignee, {
			emitEvent: false,
		});
		this.approverUpdate.next(assignee);
	}
}
